import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { LeadAppLinkEntity } from '../../../entities/mdqx/leadapp/lead-app-link.entity';
import { LeadAppLinkActionTypes } from '../../actions/mdqx/lead-app-link.actions';
import { getLatestUpdatedAt } from '../../../helper/reducer.helper';
import { LeadAppLinkActivityEntity } from '../../../entities/mdqx/leadapp/lead-app-link-activity.entity';
import { LeadAppLinkActivityActionTypes } from '../../actions/mdqx/lead-app-link-activity.action';

export const LEAD_APP_LINK_ACTIVITY_KEY = 'lead-app-link-activity';

export interface LeadAppLinkActivityState extends EntityState<LeadAppLinkActivityEntity> {
}

const adapter = createEntityAdapter<LeadAppLinkActivityEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({

});

export const leadAppLinkActivityReducer = createReducer(
    initialState,


    on(LeadAppLinkActivityActionTypes.GetSuccess, (state, { Payload }) => {
        return adapter.setAll(Payload, state);
    }),


    on(LeadAppLinkActivityActionTypes.GetFailure, (state, { Payload }) => {
        return state;
    })
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectLeadAppLinkActivityEntities = selectEntities;


